export default "__VITE_ASSET__DHCxQ3Ar__"